import { currencySymbol } from "../../../../../constants/utils";
import atoms from "../../../../atoms";
import { InventoryFooterSectionProps } from "../interface";



const {Input,TextArea } = atoms;

export const InventoryFooterSection: React.FC<
  InventoryFooterSectionProps
> = ({regionCode,errors,invoiceData,handleChange,showActualInvoice}) => {
  return (
    <>
{ (showActualInvoice) &&  <div className="row mt-4">
        <div className="col-4">
          <Input
            label={`Total Actual Invoice (${currencySymbol(regionCode)})`}
            type={"number"}
            placeholder={"Actual Invoice"}
            value={invoiceData.actual_invoice}
            errors={errors.actual_invoice}
            onChange={(e: any) => {
              handleChange("actual_invoice", e.target.value);
            }}
          />
        </div>
        <div className="col-8"></div>
      </div>}
      <div className="mt-25">
        <TextArea
          label={"Remark"}
          type={'text'}
          placeholder={"Enter Your Remark Here"}
          value={invoiceData?.remark}
          errors={errors.remark}
          onChange={(e: any) => {
            handleChange("remark", e.target.value);
          }}
          rows={3}
        />
      </div>
    </>
  );
};
